import type { Theme } from '@mui/material/styles';

const LoadingButton = (theme: Theme) => {
  return {
    MuiLoadingButton: {
      styleOverrides: {
        loadingIndicatorEnd: {
          right: 14,
        },
        loadingIndicatorStart: {
          left: 14,
        },
      },

      variants: [
        {
          props: { loading: true, loadingPosition: 'start', size: 'small' },
          style: {
            '& .MuiLoadingButton-loadingIndicatorStart': {
              left: 10,
            },
          },
        },
        {
          props: { loading: true, loadingPosition: 'end', size: 'small' },
          style: {
            '& .MuiLoadingButton-loadingIndicatorEnd': {
              right: 10,
            },
          },
        },
      ],
    },
  };
};

export default LoadingButton;
